import { render } from "./NavBar.vue?vue&type=template&id=55229766"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=55229766&lang=css"
script.render = render

export default script